import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const UsersLayout = lazy(() => import('@/pages/users/layout'));
const UsersListPage = lazy(() => import('@/pages/users'));
const UserCreatePage = lazy(() => import('@/pages/users/create'));
const UserDetailLayout = lazy(() => import('@/pages/users/detail/layout'));
const UserDetailIndexPage = lazy(() => import('@/pages/users/detail'));
const UserOverallPage = lazy(() => import('@/pages/users/detail/overall'));
const UserUpdatePage = lazy(() => import('@/pages/users/detail/update'));
const UserPermissionsPage = lazy(() => import('@/pages/users/detail/permissions'));
const UserAssessmentsListPage = lazy(() => import('@/pages/users/detail/userAssessments'));
const UserAssessmentViewPage = lazy(() => import('@/pages/users/detail/userAssessments/view'));
const UserDocumentsPage = lazy(() => import('@/pages/users/detail/documents'));

/**
 * UG-4500 — user entity routes (legacy `app/(dashboard)/users/*`).
 * `UserDetailLayout` is the legacy `[userId]/layout.tsx` shell (user fetch +
 * toolbar chrome, UG-4756) around the Profile (`/overall`) / User Assessment /
 * Documents (UG-4506) / Settings (`/update`, UG-4756) / Permissions (UG-5193)
 * pages; the bare detail URL redirects to `/overall`.
 * Permissions: `@/config/auth/routeAccess` (`/users`, `/users/create`,
 * `/users/[id]/update`, `/users/[id]/permissions`); the other sub-pages gate like legacy — hidden nav
 * items + API-enforced reads, no route rules. `UsersLayout` mounts the
 * section breadcrumb (UG-4513).
 */
export const userRoutes: RouteConfig = {
  path: '/users',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: UsersLayout,
      children: [
        { path: '', element: UsersListPage },
        { path: '/create', element: UserCreatePage },
        {
          path: '/:userId',
          layout: UserDetailLayout,
          children: [
            { path: '', element: UserDetailIndexPage },
            { path: '/overall', element: UserOverallPage },
            { path: '/update', element: UserUpdatePage },
            { path: '/permissions', element: UserPermissionsPage },
            { path: '/user-assessments', element: UserAssessmentsListPage },
            { path: '/user-assessments/:assessmentId/view', element: UserAssessmentViewPage },
            { path: '/documents', element: UserDocumentsPage },
          ],
        },
      ],
    },
  ],
};
